import { CardDeck } from "./cardDeck/cardDeck";
import { SeatBox } from "./seatBox/seatBox";
// import { PlayerStars } from "./playerStars";
import { IdleSeat } from "./idleSeat";
import { Bet } from "./bet";
// import { DealerChip } from "./dealerChip";
import { Actions } from "./actions";
import { Helpers } from "../../../../helpers/helpers";
import { WinAmount } from "./winAmount";
import { Avatar } from "./avatar";
// import { ShowHandBtn } from "./showHandBtn";
import { TextMessage } from "./textMessage";
import { gameConfig } from "../../../../helpers/gameConfig";
import localScaleManager from "../../../../helpers/LocalScaleManager";

export default class Seat {
  /**
   * @param scene {GameScene}
   * @param table {Table} needs for click on seat plus
   * @param position {"cb" | "lb2" | "lb1" | "lt1" | "lt2" | "ct" | "rt2" | "rt1" | "rb1" | "rb2" } r: right, l: left, t: top, b: bottom, c: center
   * @param serverPosition {number}
   * @param seatNumber {number} seat index in table seats list
   * @param isMyTable {boolean} self player seat or not
   * @param idle {boolean} player seat or not
   * @param cardsType {"2-cardDeck" | "4-cardDeck"| "5-cardDeck"} cards Type based on table type
   */
  constructor(
    scene,
    table,
    position,
    serverPosition,
    isMyTable,
    idle,
    cardsType,
    test
  ) {
    this.scene = scene;
    this.table = table;
    this.position = position;
    this.serverPosition = serverPosition;

    this.idle = idle;
    this.playerInfo = "";
    this.playerId = "";
    this.cardsType = cardsType;
    this.cardsLength = 0;
    this.cardsDealingdelay = 20;
    this.createCards();
    this.box = new SeatBox(scene, `test ${test}`, this.table);

    // this.playerStars = new PlayerStars(scene, 5, this.table);

    if (!this.table.isTournamentTable())
      this.idleSeat = new IdleSeat(scene, this.table, this);

    this.playerBet = new Bet(scene, this.table, isMyTable);
    // this.dealer = new DealerChip(scene, this.table);
    this.dealerX = 0;
    this.dealerY = 0;
    this.actions = new Actions(scene, this.table, isMyTable, this);
    this.avatar = new Avatar(scene, isMyTable, this, this.table);
    this.winAmount = new WinAmount(scene, this.table, this);

    // this.showHand = new ShowHandBtn(scene, this.table, this);

    if (this.table.tableInfo.chatEnabled)
      this.messageBox = new TextMessage(scene, this.table);
    this.isMyTable = isMyTable;
    this._isMyTable = isMyTable;
    if (!this.isMyTable) {
      if (this.idle) {
        this.setIdle();
      } else {
        this.unSetIdle();
      }
    } else {
      this.unSetIdle();
    }
    this.disconnectGlow = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "disconnect-box")
      .setOrigin(0.5)
      .setVisible(false);
    this.table.poolArray.push(this.disconnectGlow);

    this.disconnect = this.scene.add
      .bitmapText(0, 0, "disconnected", "Disconnected")
      .setVisible(false)
      .setOrigin(0.5);
    this.disconnect.setData("width", this.disconnect.width);
    this.disconnect.setData("height", this.disconnect.height);
    this.table.poolArray.push(this.disconnect);
    this.childObjectsGroup = this.scene.add.group([
      this.box,
      this.disconnect,
      this.box.usernameTxt,
      this.box.balanceTxt,
      this.box.boxShadow,
      // ...this.playerStars.starsList.getChildren(),
      // ...this.cards.upsideDownCards,
      ...this.cards.children,
      // this.showHand,
      this.avatar,
      // this.avatar.bg,
    ]);
    if (this.idleSeat) this.childObjectsGroup.add(this.idleSeat);
    this.table.poolArray.push(this.childObjectsGroup);
    this.playerTurnGroup = this.scene.add.group([
      // this.box.activeSeatBox,
      this.box.usernameTxt,
      this.box.balanceTxt,
      // ...this.playerStars.starsList.getChildren(),
      // ...this.cards.upsideDownCards,
      ...this.cards.children,
      this.avatar,
      // this.avatar.bg,
      // this.box.timer.star,
      // this.box.timer.line,
      // this.box.timer.lineBg,
    ]);
    this.table.poolArray.push(this.playerTurnGroup);

    // Phaser.Actions.SetDepth([...this.childObjectsGroup.getChildren(), this.box.timer.line, this.box.timer.lineBg], 12);
    Phaser.Actions.SetDepth(this.childObjectsGroup.getChildren(), 12);
    Phaser.Actions.SetDepth([...this.cards.children], 10);
    this.avatar.setDepth(9);
    this.box.boxShadow.setDepth(1);
    // this.avatar.bg.setDepth(8);
    // this.showHand.setDepth(15);
    this.betPlayerObjectsGroup = this.scene.add.group([
      this.playerBet.text,
      // this.playerBet.textBox,
      this.playerBet.chips,
    ]);
    this.table.poolArray.push(this.betPlayerObjectsGroup);

    this.changePositionTweenConfig = {
      delay: 200,
      duration: 300,
      // duration: 400,
      // ease: "Back",
      ease: "Circular",
    };
    // this.initPlayTurnTween();
    this.showWinCardsTweenConfig = {
      duration: 500,
      repeat: 3,
      delay: 600,
    };
  }

  set isMyTable(boolean) {
    this._isMyTable = boolean;
    this.playerBet.isMyTable = boolean;
    this.actions.isMyTable = boolean;
    this.avatar.isMyTable = boolean;
  }

  get isMyTable() {
    return this._isMyTable;
  }

  async updatePlayerInfo(playerInfo, gameState) {
    const newState = gameState.newState,
      state = gameState.state,
      returnPot = gameState.returnPot,
      winners = gameState.winners;
    // this.setIdle();
    this.playerInfo = playerInfo;
    this.playerId = playerInfo.playerId;
    if (this.idleSeat) this.idleSeat.visibilityControls(false);
    // if( playerInfo.joinMode === "Joined" && state !== 'Idle' && state !== 'PreFlop' || (state === 'PreFlop' && !newState)) {
    if (playerInfo.online) {
      if (this.disconnect.visible) this.disconnect.setVisible(false);
      if (this.disconnectGlow.visible) this.disconnectGlow.setVisible(false);
    } else {
      if (!this.disconnect.visible) this.disconnect.setVisible(true);
      if (!this.disconnectGlow.visible) this.disconnectGlow.setVisible(true);
    }
    if (
      playerInfo.lastAction === "Fold" ||
      playerInfo.state === "SitOut" ||
      playerInfo.state === "Leaving" ||
      playerInfo.state === "WaitToJoin" ||
      playerInfo.state === "WaitToStart" ||
      gameState.state === "Rebuy" ||
      gameState.state === "Straddle"
    ) {
      this.cards.visibilityControls(false);
      this.cards.handVisibilityControls(false);
      this.cards.clearCards();
    } else if (
      (playerInfo.joinMode === "Joined" &&
        state !== "Idle" &&
        state !== "PreFlop") ||
      (state === "PreFlop" && !newState)
    ) {
      this.cards.visibilityControls(true);
      this.cards.handVisibilityControls(false);
    }
    if (
      (newState &&
        this.playerBet.bet &&
        state !== "PreFlop" &&
        state !== "Idle") ||
      (gameState.src === "redeal type ask" && gameState.askRedeal)
    ) {
      this.playerBet.stackChips(
        this.table.pots.centerPot.chips.x,
        this.table.pots.centerPot.chips.y
      );
    }
    if (!returnPot || returnPot.playerId !== this.playerId)
      this.box.updatePlayerInfo(playerInfo, state);
    this.updateWinners(winners);
    this.box.visibilityControls(true);
    this.avatar.updateAvatar(playerInfo.avatar, false);
    // this.playerStars.updatePlayerInfo(playerInfo);
    if (
      state !== "Idle" &&
      (state !== "PreFlop" || (state === "PreFlop" && !newState)) &&
      playerInfo.state !== "SitOut" &&
      playerInfo.state !== "WaitToJoin" &&
      playerInfo.state !== "WaitToStart"
    ) {
      if (playerInfo.hand.length > 0) {
        this.cards.showHand(this.playerInfo.hand);
        // this.table.showHandMenu.show();
      }
    }
    if (this.updatePlayerBetConditions(state, newState)) {
      this.playerBet.updatePlayerBet(playerInfo);
    } else if (state === "Idle") {
      this.playerBet.visibilityControls(false);
    }
    // if (playerInfo.state !== "AllIn" && !gameState.reDealing) {
    if (!gameState.reDealing) {
      // if(!newState && this.playerId === this.table.previousPlayerInTurn){
      if (
        this.playerId === this.table.previousPlayerInTurn &&
        this.table.previousPlayerInTurn !== this.table.gameState.playerInTurn
      ) {
        this.actions.showAction(playerInfo.lastAction);
      }
    }
    // else {
    //     this.actions.showAction(playerInfo.lastAction);
    // }
    if (
      playerInfo.lastAction === "Fold" ||
      playerInfo.state === "SitOut" ||
      playerInfo.state === "Leaving" ||
      playerInfo.afk
    ) {
      if (
        playerInfo.afk ||
        playerInfo.state === "Leaving" ||
        playerInfo.state === "SitOut"
      ) {
        this.actions.showAction("SitOut");
      }
      //  else {
      //   this.actions.showAction(playerInfo.lastAction);
      // }
      this.setDisable(true);
    } else {
      this.actions.hide(this.actions.away);
      this.setDisable(false);
    }
    if (
      returnPot &&
      returnPot.amount !== 0 &&
      returnPot.playerId === this.playerId
    ) {
      await this.playerBet.returnChipsToPlayer();
      this.box.updatePlayerInfo(playerInfo, state);
    }
    if (state === "End" && !playerInfo.showHandButton) {
      // if (gameState.src !== "showhand") {
      // if (!playerInfo.showHand) {
      this.cards.cardsList.forEach((card) => {
        // if (card.visible && !card.overlay.visible)
        //   card.overlay.setVisible(true);
        if (
          card.visible &&
          !(
            playerInfo.win > 0 &&
            playerInfo.bestHand?.hand.find((c) => c.code === card.code)
          )
        ) {
          card.showCardOverlay();
        }
      });
    }
    if (playerInfo.showHandCards?.length !== 0) {
      this.cards.visibilityControls(false);
      this.cards.showHand(playerInfo.showHandCards);
    }
    // }
  }
  updatePlayerBetConditions(state, newState) {
    let status = true;
    switch (state) {
      case "Idle": {
        status = false;
        break;
      }
      case "PreFlop": {
        status = !newState;
        break;
      }
      case "Straddle": {
        status = !newState;
        break;
      }
    }
    return status;
  }
  async updateSelfPlayer(playerInfo, gameState) {
    const newState = gameState.newState,
      state = gameState.state,
      returnPot = gameState.returnPot,
      winners = gameState.winners;
    // if (!this.table.selfPlayerGlow.visible)
    //   this.table.selfPlayerGlow.setVisible(true);
    if (playerInfo.askForShowHand) {
      // this.showHand.visibilityControls(true);
      this.table.showHandMenu.show();
    } else {
      // this.showHand.visibilityControls(true);
      this.table.showHandMenu.hide();
    }
    this.isMyTable = true;
    this.playerInfo = playerInfo;
    this.playerId = playerInfo.id;
    if (this.idleSeat) this.idleSeat.visibilityControls(false);
    // if (playerInfo.lastAction === 'Fold' ||
    if (playerInfo.online) {
      if (this.disconnect.visible) this.disconnect.setVisible(false);
      if (this.disconnectGlow.visible) this.disconnectGlow.setVisible(false);
    } else {
      if (!this.disconnect.visible) this.disconnect.setVisible(true);
      if (!this.disconnectGlow.visible) this.disconnectGlow.setVisible(true);
    }
    if (
      playerInfo.state === "SitOut" ||
      playerInfo.state === "WaitToJoin" ||
      playerInfo.state === "Leaving" ||
      playerInfo.state === "WaitToStart"
    ) {
      this.cards.visibilityControls(false);
      if (!this.avatar.isClicked) this.cards.handVisibilityControls(false);
      this.cards.clearCards();
    } else {
      this.cards.handsUpdate(playerInfo.hand);
      if (
        (state === "PreFlop" && newState) ||
        playerInfo.hand.length === 0 ||
        state === "Idle" ||
        playerInfo.lastAction === "Fold" ||
        playerInfo.state === "SitOut"
      ) {
        // if(state === 'PreFlop' || playerInfo.hand.length === 0 ) {
        if (!this.avatar.isClicked) this.cards.handVisibilityControls(false);
      } else {
        this.cards.handVisibilityControls(true);
      }
    }
    if (
      (newState &&
        this.playerBet.bet &&
        state !== "PreFlop" &&
        state !== "Idle") ||
      (gameState.src === "redeal type ask" && gameState.askRedeal)
    ) {
      this.playerBet.stackChips(
        this.table.pots.centerPot.chips.x,
        this.table.pots.centerPot.chips.y
      );
    }
    this.avatar.updateAvatar(
      playerInfo.avatar,
      true,
      (playerInfo.lastAction === "Fold" ||
        playerInfo.state === "SitOut" ||
        (playerInfo.state === "WaitToJoin" &&
          !this.table.isTournamentTable())) &&
        playerInfo.hand.length !== 0
    );
    if (!returnPot || returnPot.playerId !== this.playerId)
      this.box.updatePlayerInfo(playerInfo, state);
    this.updateWinners(winners);
    this.box.visibilityControls(true);
    // this.playerStars.updatePlayerInfo(playerInfo);
    this.playerBet.isMyTable = true;
    if (this.updatePlayerBetConditions(state, newState)) {
      this.playerBet.updatePlayerBet(playerInfo);
    } else if (state === "Idle") {
      this.playerBet.visibilityControls(false);
    }
    // if (playerInfo.state !== "AllIn" && !gameState.reDealing) {
    if (!gameState.reDealing) {
      // if (!newState && this.playerId === this.table.previousPlayerInTurn) {
      if (
        this.playerId === this.table.previousPlayerInTurn &&
        this.table.previousPlayerInTurn !== this.table.gameState.playerInTurn
      ) {
        this.actions.isMyTable = true;
        this.actions.showAction(playerInfo.lastAction);
      }
      // if(
      //     playerInfo.bestHand &&
      //     !(state === 'Flop' && gameState.newState) &&
      //     !(state === 'Flop' && !gameState.newState && !this.table.cards.areFlopCardsShown)
      // )
      // {
      //     this.table.bestHand.show(playerInfo.bestHand.type);
      // }
      // else {
      //     this.table.bestHand.hide();
      // }
    }
    // else {
    //     this.actions.showAction(playerInfo.lastAction);
    // }
    if (
      playerInfo.lastAction === "Fold" ||
      playerInfo.state === "SitOut" ||
      playerInfo.state === "Leaving" ||
      playerInfo.afk
    ) {
      if (
        playerInfo.afk ||
        playerInfo.state === "Leaving" ||
        playerInfo.state === "SitOut"
      ) {
        this.actions.showAction("SitOut");
      }
      //  else {
      //   this.actions.showAction(playerInfo.lastAction);
      // }
      this.setDisable(true);
    } else {
      this.actions.hide(this.actions.away);
      this.setDisable(false);
    }
    if (
      returnPot &&
      returnPot.amount !== 0 &&
      returnPot.playerId === this.playerId
    ) {
      await this.playerBet.returnChipsToPlayer();
      this.box.updatePlayerInfo(playerInfo, state);
    }
    if (!playerInfo.bestHand) {
      this.table.bestHand.hide();
    }
    // if (state === "End" && gameState.src !== "showhand") {
    // if (state === "End" && gameState.src !== "showhand") {
    if (state === "End" && !playerInfo.showHandButton) {
      this.cards.cardsList.forEach((card) => {
        // if (card.visible && !card.overlay.visible && !(playerInfo.win > 0 && playerInfo.bestHand?.hand.find(c => c.code === card.code)))
        // card.overlay.setVisible(true);
        if (
          card.visible &&
          !(
            playerInfo.win > 0 &&
            playerInfo.bestHand?.hand.find((c) => c.code === card.code)
          )
        ) {
          card.showCardOverlay();
        }
      });
    }
  }

  /**
   * seat without player
   */
  setIdle() {
    const gameState = this.table.gameState;
    this.playerInfo = {};
    this.playerId = "";
    this.cards.visibilityControls(false);
    this.cards.clearCards();
    if (!this.avatar.isClicked) this.cards.handVisibilityControls(false);
    // this.box.deactivate();
    this.box.visibilityControls(false);
    // this.playerStars.visibilityControls(false);

    // this.dealer.visibilityControls(false);
    this.avatar.visibilityControls(false);
    if (
      (gameState &&
        gameState.playerInfo &&
        gameState.playerInfo &&
        gameState.playerInfo.joinMode !== "Reserved") ||
      this.table.isTournamentTable()
    ) {
      if (this.idleSeat) this.idleSeat.visibilityControls(false);
    } else {
      if (this.idleSeat) this.idleSeat.visibilityControls(true);
    }
    // this.showHand.visibilityControls(false);
    // if(this.table.showHandMenu) this.table.showHandMenu.hide();

    this.setDisable(false);
    if (gameState?.src !== "showhand")
      Phaser.Actions.SetY(this.cards.cardsList, this.cards.cardsY);
    // if(this.log)this.log.setText(this.serverPosition).setVisible(true);
  }

  /**
   * for clearing chips if they are still visible
   */
  empty() {
    this.setIdle();
    this.disconnect.setVisible(false);
    this.disconnectGlow.setVisible(false);
    this.playerBet.visibilityControls(false);
  }

  /**
   * seat with player
   */
  unSetIdle() {
    this.cards.handVisibilityControls(true);
    this.box.visibilityControls(true);
    // this.playerStars.visibilityControls(true);
    this.playerBet.visibilityControls(true);
    // this.dealer.visibilityControls(true);
    this.avatar.visibilityControls(true);
    if (this.idleSeat) this.idleSeat.visibilityControls(false);
    // this.showHand.visibilityControls(false);
  }

  activate(sameState) {
    if (this.isMyTable) {
      if (!sameState) {
        if (this.scene.vibrationAllowed && window.navigator.vibrate) {
          try {
            window.navigator.vibrate(300);
          } catch (e) {}
        }
        // let timer = this.scene.time.addEvent({
        //     delay: delay ? delay : 1000,                // ms
        //     callback: () => {
        //         this.table.sounds.play("timer");
        //         timer.destroy();
        //         this.box.activate(this.playerInfo);
        //         this.actions.visibilityControls(false);
        //         this.actions.hide(this.actions.fold);
        //         this.actions.hide(this.actions.away);
        //         this.scene.header.tablesNav.tables[this.table.tableNumber - 1].startTimer(this.playerInfo.timeRemaining);
        //
        //     },
        //     callbackScope: this,
        //     loop: false
        // })
        this.table.sounds.play("time-action-warning");
      }
    }
    // else {
    if (
      !(
        this.playerInfo.state === "SitOut" ||
        this.playerInfo.state === "WaitToJoin" ||
        this.playerInfo.state === "WaitToStart" ||
        this.playerInfo.afk
      )
    ) {
      this.box.activate(this.playerInfo);
      if (this.isMyTable) {
        if (
          !sameState ||
          (sameState && this.table.firstGameState) ||
          this.table.gameState.src === "UseTimeBank"
        ) {
          this.scene.header.tablesNav.tables[
            this.table.tableNumber - 1
          ].startTimer(this.playerInfo.timeRemaining);
        }
      }
    }
    this.actions.visibilityControls(false);
    this.actions.hide(this.actions.fold);
    this.actions.hide(this.actions.away);
    // }
  }

  deactivate() {
    // if(this.scene.isAudioAllowed(this.table) && this.isMyTable) {
    if (this.isMyTable) {
      const sound = this.table.sounds.find("timer");
      if (sound.isPlaying) this.table.sounds.find("timer").stop();
    }
    this.box.deactivate();
    // this.playTurnTween.pause();
    if (this.isMyTable)
      this.scene.header.tablesNav.tables[
        this.table.tableNumber - 1
      ].clearTimer();

    if (this.table.turnTimer.playerId === this.playerId) {
      this.table.turnTimer.stopTimer();
    }
  }

  // initPlayTurnTween() {
  //   this.playTurnTween = this.scene.tweens.add({
  //     targets: this.box.activeSeatBox,
  //     yoyo: true,
  //     repeat: 10,
  //     ease: "Linear",
  //     scale: "* = 1.1",
  //     duration: 500,
  //     paused: true,
  //     onComplete: () => {},
  //   });
  // }

  setDisable(status) {
    this.cards.setDisable(status);
    if (!status && this.playerInfo.afk) return;
    this.box.setDisable(status);
    // this.avatar.setDisable(status);
    // this.cards.cardsList.forEach(card => {
    //     if(card.visible) card.overlay.setVisible(true);
    // })
    // this.playerStars.starsList.children.iterate(star => star.clearTint());
  }

  updateWinners(winners) {
    if (winners.length > 0) {
      const iWon = winners.find(
        (winner) => winner.position === this.playerInfo.position
      );
      if (iWon) {
        this.winAmount.update(iWon.win);
      }
    }
  }
  compeleteWin() {
    this.winAmount.winBox.setVisible(false);
    this.winAmount.winGlow.setVisible(false);
    this.winAmount.winStar.setVisible(false);
    this.winAmount.winTxt.setVisible(false);
    this.winAmount.text.setVisible(false);
    this.box.resetAlpha();
  }
  /**
   * @param {{round: 0|1|2, win: number}[]} win
   */
  win(win) {
    // this.childObjectsGroup.getChildren().forEach(child => {
    //     // child.setTint(0xfff38a);
    //     child.setTint(0xfcff6a, 0xfadf7a, 0xa97f45, 0x7c6048);
    // });
    this.winAmount.playWinTween();
    if (this.playerInfo.bestHandsList)
      this.playerInfo.bestHandsList.forEach((bestHand, i) => {
        if (win.find((w) => w.round === i)) {
          this.showWinCards(bestHand, i, this.playerInfo.bestHandsList.length);
        }
      });
    else if (this.playerInfo.bestHand)
      this.showWinCards(this.playerInfo.bestHand, 0);
  }

  showWinCards(bestHand, i, bestHandsLength) {
    // this.winnerCardsGroup.clear();
    let winnerCardsGroup = this.scene.add.group(),
      cardsSpritesDomain;
    this.table.poolArray.push(winnerCardsGroup);
    const tableCards1 = this.table.cards,
      tableCards2 = this.table.cards2,
      tableCards3 = this.table.cards3;
    // cardsSpritesDomain = [...this.cards.cardsList];
    switch (i + 1) {
      case 1: {
        // tableCards = this.table.cards;
        cardsSpritesDomain = [
          ...this.cards.cardsList,
          ...tableCards1.cardsList.getChildren(),
        ];
        break;
      }
      case 2: {
        // tableCards = this.table.cards2;
        if (tableCards2.areFlopCardsShown) {
          cardsSpritesDomain = [
            ...this.cards.cardsList,
            ...tableCards2.cardsList.getChildren(),
          ];
        } else if (tableCards2.isTurnCardShown) {
          cardsSpritesDomain = [
            ...this.cards.cardsList,
            ...tableCards1.getFlopCards(),
            tableCards2.getTurnCard(),
            tableCards2.getRiverCard(),
          ];
        } else {
          cardsSpritesDomain = [
            ...this.cards.cardsList,
            ...tableCards1.getFlopCards(),
            tableCards1.getTurnCard(),
            tableCards2.getRiverCard(),
          ];
        }
        break;
      }
      case 3: {
        // tableCards = this.table.cards3;
        if (tableCards3.areFlopCardsShown) {
          cardsSpritesDomain = [
            ...this.cards.cardsList,
            ...tableCards3.cardsList.getChildren(),
          ];
        } else if (tableCards3.isTurnCardShown) {
          cardsSpritesDomain = [
            ...this.cards.cardsList,
            ...tableCards1.getFlopCards(),
            tableCards3.getTurnCard(),
            tableCards3.getRiverCard(),
          ];
        } else {
          cardsSpritesDomain = [
            ...this.cards.cardsList,
            ...tableCards1.getFlopCards(),
            tableCards1.getTurnCard(),
            tableCards3.getRiverCard(),
          ];
        }
        break;
      }
    }
    cardsSpritesDomain.forEach((card) => {
      // if (card.visible && !card.overlay.visible) card.overlay.setVisible(true);
      if (card.visible) card.showCardOverlay();
    });
    bestHand.hand.forEach((hand) => {
      const winCard = cardsSpritesDomain.find(
        (card) => card.frame.name === Helpers.getCardsFrameByCode(hand.code)
      );
      // if(winCard) winCard.setTint(0xfff38a);
      if (winCard) winnerCardsGroup.add(winCard);
    });
    if (winnerCardsGroup.getChildren().length > 0) {
      const duration = gameConfig.endStateDuration / bestHandsLength;
      const delay = i * duration + this.showWinCardsTweenConfig.delay;
      const yDuration = 200;
      // let overlays = winnerCardsGroup.getChildren().map(card => card.overlay);
      winnerCardsGroup.children.iterate(function (child, j) {
        // child.overlay.setVisible(false);
        // if(j !== 0) {
        if (this.scene.tweenEnable) {
          this.scene.tweens.add({
            targets: child,
            y: `-=${child.displayHeight / 8}`,
            ease: "Linear",
            duration: yDuration,
            yoyo: true,
            hold: duration - 2 * yDuration - this.showWinCardsTweenConfig.delay,
            delay: delay,
            onStart: () => {
              // if (child.overlay.visible) child.overlay.setVisible(false);
              // if(this.table.gameState.state !== 'End') 
              child.hideCardOverlay();
            },
            onComplete: () => {
              // if (i !== bestHandsLength - 1 && !child.overlay.visible)
              //   child.overlay.setVisible(true);
              if (i !== bestHandsLength - 1) child.showCardOverlay();
            },
          });
        } else {
          // if (child.overlay.visible) child.overlay.setVisible(false);
          child.hideCardOverlay();
        }
      }, this);
    }
  }

  /**
   * seat with player in Idle game state
   */
  idleState() {
    this.cards.handVisibilityControls(false);
    this.cards.cardsList.forEach((card) => {
      card.clearTint();
    }, this);
  }

  /**
   * @param nextPosition: {position: string,
   *                       boxX: number
   *                       boxY: number
   *                       dealerX: number
   *                       dealerY: number
   *                       betX: number
   *                       betY: number
   *                       }
   * @param {boolean} useTween
   */
  async changePosition(nextPosition, useTween) {
    const deltaX = nextPosition.boxX - this.box.x;
    const deltaY = nextPosition.boxY - this.box.y;
    const deltaDealerX = nextPosition.dealerX - this.table.dealer.x;
    const deltaDealerY = nextPosition.dealerY - this.table.dealer.y;
    const deltaBetX = nextPosition.betX - this.playerBet.chips.x;
    const deltaBetY = nextPosition.betY - this.playerBet.chips.y;
    return new Promise((resolve, reject) => {
      this.dealerX += deltaDealerX;
      this.dealerY += deltaDealerY;
      if (this.scene.tweenEnable && !this.table.firstGameState && useTween) {
        this.scene.tweens.add({
          ...this.changePositionTweenConfig,
          targets: this.childObjectsGroup.getChildren(),
          y: `+=${deltaY}`,
          x: `+=${deltaX}`,
          onComplete: () => {
            if (this.cards.cardsList[0].upsideDown.visible)
              this.cards.arrangeCards();
            resolve();
          },
        });
        // this.scene.tweens.add({
        //   ...this.changePositionTweenConfig,
        //   targets: this.table.dealer,
        //   ease: "Linear",
        //   y: `+=${deltaDealerY}`,
        //   x: `+=${deltaDealerX}`,
        // });
        this.scene.tweens.add({
          ...this.changePositionTweenConfig,
          targets: this.betPlayerObjectsGroup.getChildren(),
          ease: "Linear",
          y: `+=${deltaBetY}`,
          x: `+=${deltaBetX}`,
        });
      } else {
        Phaser.Actions.IncY(this.childObjectsGroup.getChildren(), deltaY);
        Phaser.Actions.IncX(this.childObjectsGroup.getChildren(), deltaX);
        // this.table.dealer.setPosition(
        //   this.table.dealer.x + deltaDealerX,
        //   this.table.dealer.x + deltaDealerX
        // );
        Phaser.Actions.IncY(
          this.betPlayerObjectsGroup.getChildren(),
          deltaBetY
        );
        Phaser.Actions.IncX(
          this.betPlayerObjectsGroup.getChildren(),
          deltaBetX
        );
        if (this.cards.cardsList[0].upsideDown.visible)
          this.cards.arrangeCards();
        resolve();
      }
    });
  }

  async dealingCardsToPlayers(seats) {
    let seat,
      promisesList = [],
      upsideDownCardScale;
    const playingSeats = seats.filter(
      (seat) =>
        seat.playerInfo.joinMode && seat.playerInfo.joinMode === "Joined"
    );
    for (let j = 0; j < this.cardsLength; j++) {
      for (let i = 0; i < playingSeats.length; i++) {
        seat = playingSeats[i];
        // if(seat.playerInfo.joinMode && seat.playerInfo.joinMode === "Joined") {
        if (seat.isMyTable) {
          upsideDownCardScale = playingSeats.find((s) => !s.isMyTable).cards
            .cardsList[0].upsideDown.scale;
        }
        promisesList.push(
          seat.cards.getCardFromDealer(
            this.table.dealer.x,
            this.table.dealer.y,
            j,
            j * playingSeats.length * this.cardsDealingdelay +
              i * this.cardsDealingdelay,
            upsideDownCardScale,
            seat.isMyTable
          )
        );
        // }
      }
    }
    return new Promise((resolve, reject) => {
      Promise.all(promisesList)
        .then(() => resolve())
        .catch((e) => {
          console.error(e);
          reject();
        });
      // try {
      //     await Promise.all(promisesList);
      // }
      // catch (e) {
      //     console.error(e);
      // }
    });
  }

  yourTurn() {
    this.box.activate();
  }

  /**
   * @param number{number} new seat number;
   */
  changeSeatNumber(number) {
    this.seatNumber = number;
  }

  createCards() {
    switch (this.cardsType) {
      case "2-cardDeck": {
        this.cardsLength = 2;
        break;
      }
      case "4-cardDeck": {
        this.cardsLength = 4;
        break;
      }
      case "5-cardDeck": {
        this.cardsLength = 5;
        break;
      }
    }
    this.cards = new CardDeck(this.scene, this.table, this.cardsLength, this);
  }

  handleVisibilityChange(hidden) {
    this.cards.handleVisibilityChange(hidden);
    this.playerBet.handleVisibilityChange(hidden);
    this.winAmount.handleVisibilityChange(hidden);
  }

  /***
   * @param width {number} width of table
   * @param height {number} width of table
   * @param initX {number} table top left x
   * @param initY {number} table top left y
   */
  positionControls(width, height, initX, initY) {
    this.box.positionControls(width, height, initX, initY, this.isMyTable);
    this.cards.positionControls(
      this.box.displayWidth,
      this.box.displayHeight,
      this.box.x,
      this.box.y
    );
    // this.playerStars.positionControls(
    //   this.box.displayWidth,
    //   this.box.displayHeight,
    //   this.box.x,
    //   this.box.y
    // );
    if (this.idleSeat)
      this.idleSeat.positionControls(
        this.box.displayHeight,
        this.box.displayWidth,
        this.box.displayHeight,
        this.box.x,
        this.box.y
      );
    this.playerBet.positionControls(
      this.box.displayWidth,
      this.box.displayHeight,
      this.box.x,
      this.box.y
    );
    this.actions.positionControls(
      this.box.displayWidth,
      this.box.displayHeight,
      this.box.x,
      this.box.y
    );
    this.winAmount.positionControls(
      this.box.displayWidth,
      this.box.displayHeight,
      this.box.x,
      this.box.y
    );
    this.avatar.positionControls(
      this.box.displayWidth,
      this.box.displayHeight,
      this.box.x,
      this.box.y
    );
    // this.showHand.positionControls(
    //   this.box.displayWidth,
    //   this.box.displayHeight,
    //   this.box.x,
    //   this.box.y
    // );
    if (this.table.tableInfo.chatEnabled)
      this.messageBox.positionControls(
        this.box.displayWidth,
        this.box.displayHeight,
        this.box.x,
        this.box.y,
        this.isMyTable
      );

    localScaleManager.scaleBitMapText(
      this.disconnect,
      this.box.displayWidth / 1.5,
      this.box.displayHeight / 3.5,
      0,
      1,
      false
    );
    localScaleManager.scaleSprite(
      this.disconnectGlow,
      this.box.displayWidth * 1.43,
      this.box.displayHeight * 1.43,
      0,
      1,
      true
    );
    this.disconnectGlow.setPosition(this.box.x, this.box.y);
    this.disconnect.setPosition(
      this.box.x,
      this.box.y - this.box.displayHeight * 1.3
    );
    // this.log.setPosition(
    //   this.box.x + (this.box.displayWidth - this.log.width) / 2,
    //   this.box.y + this.box.displayHeight - this.log.height / 4
    // );
  }
  /***
   * @param width {number} width of table
   * @param height {number} width of table
   * @param initX {number} table top left x
   * @param initY {number} table top left y
   */
  reposition(width, height, initX, initY) {
    this.box.reposition(width, height, initX, initY, this.isMyTable);
    this.cards.reposition(
      this.box.displayWidth,
      this.box.displayHeight,
      this.box.x,
      this.box.y
    );
    if (this.idleSeat)
      this.idleSeat.reposition(
        width / 8,
        this.box.displayWidth,
        this.box.displayHeight,
        this.box.x,
        this.box.y
      );
    this.playerBet.reposition(
      this.box.displayWidth,
      this.box.displayHeight,
      this.box.x,
      this.box.y
    );
    this.actions.reposition(
      this.box.displayWidth,
      this.box.displayHeight,
      this.box.x,
      this.box.y
    );
    this.winAmount.reposition(
      this.box.displayWidth,
      this.box.displayHeight,
      this.box.x,
      this.box.y
    );
    this.avatar.reposition(
      this.box.displayWidth,
      this.box.displayHeight,
      this.box.x,
      this.box.y
    );
    if (this.table.tableInfo.chatEnabled)
      this.messageBox.reposition(
        this.box.displayWidth,
        this.box.displayHeight,
        this.box.x,
        this.box.y,
        this.isMyTable
      );
    this.disconnect.setPosition(
      this.box.x,
      this.box.y - this.box.displayHeight * 1.3
    );
    this.disconnectGlow.setPosition(this.box.x, this.box.y);
  }

  remove() {
    this.box.remove();
    this.cards.remove();
    // this.playerStars.remove();
    // this.idleSeat.remove();
    this.playerBet.remove();
    this.actions.remove();
    this.winAmount.remove();
    this.avatar.remove();
    // this.showHand.remove();
    // this.dealer.remove();
  }
}
